import axios from 'axios';
import {
  store
} from "@/store/index.js";
import router from '@/router/index.js';

var baseURL = process.env.API_PATH;

let instance = axios.create({
  baseURL: baseURL
});

instance.interceptors.request.use(config => {
  try {
    let sid = localStorage.sid;
    if (!sid) return config;
    if (!config.params) {
      config.params = {
        sid: sid
      };
    } else {
      config.params.sid = sid;
    }
  } catch (e) {
    console.log('eRRor', e);
  }
  return config;
});

instance.interceptors.response.use(response => {
  let data = response.data;
  if (data.message === "You are not logged in.") {
    localStorage.removeItem('sid');
    router.push("/auth");
    // UNCOMMENT WHEN ADD CANCEL TOKEN
    // store.commit('modalError', {
    //   active: true,
    //   message: data.message
    // });
  } else if (data.status === "ERR") {
    let message = data.message;
    if (!message || message.length === 0) {
      message = "Error happened on server";
    }
    store.commit("modalError", {
      active: true,
      message: '' + message,
    });
  }
  return response;
}, error => {
  return Promise.reject(error);
});

export {
  instance,
  baseURL
};



// WEBPACK FOOTER //
// ./src/api/config.js